import styled from "styled-components";
export const Styles = styled.div`
  .activity {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 15px;
    background: #fff;
    color: var(--dark-color);
    border-radius: 25px;
    box-shadow: -2px 5px 10px #46454774;
    margin-bottom: 20px;
    padding-bottom: 0;
  }
  .activity .activity-img {
    width: 100%;
    margin-bottom: 20px;
    border-radius: 25px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 193/110;
  }
  .activity .activity-img img {
    border-radius: 25px;
    overflow: hidden;
    object-fit: cover;
  }
  .activity .activity-data .activity-title {
    font-size: 13px;
    color: var(--dark-purple);
    margin-bottom: 5px;
    height: 22px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    font-weight: bold;
  }
  .activity .activity-data .activity-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
  }
  .activity .activity-data .activity-info .trainer-name{
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    font-weight: bold;
  }
  .activity .activity-data .activity-description{
    height: 42px;
  }
  .activity .activity-data .activity-info .activity-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .activity .activity-data .activity-info a,
  .activity .activity-data .activity-info button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px solid #f5f5f5;
    background: #f5f5f5;
    color: #84829a !important;
    transition: 0.3s;
  }
  .activity .activity-data .activity-info a:hover,
  .activity .activity-data .activity-info button:hover {
    border-color: var(--dark-purple);
  }
  .read-more {
    font-size: 12px;
    color: var(--dark-purple);
    white-space: nowrap;
    cursor: pointer;
  }
  .activity .activity-data .activity-details {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
  }
  .activity .activity-data .activity-details .btn {
    padding-inline: 50px;
    border-radius: 25px;
  }
  .activity .activity-data .activity-details .count {
    display: flex;
    padding-block: 15px;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .note {
    color: var(--dark-purple);
    padding: 26.5px 0;
  }
`;
